<template>
    <div style="width: 100%">
        <loader :loading="true" v-if="isLoading && showSpinner"></loader>
        <div class="requiredActions" v-if="requiredActions && amountTotal > 0">
            <div class="is-row header">
                <div class="text">
                    <span class="amount">{{ amountTotal }}</span
                    >Actions required
                </div>
            </div>
            <div class="is-row" v-if="amountToPublish > 0">
                <RequiredActionsItem
                    :forecasts="requiredActions.toPublish.forecasts"
                    :forecast-windows="requiredActions.toPublish.forecastWindows"
                    :amount="amountToPublish"
                    :title="'Forecasts to publish'"
                    :action-color="'#62a0cf'"
                />
            </div>
            <div class="is-row" v-if="amountToValidate > 0">
                <RequiredActionsItem
                    :forecasts="requiredActions.toValidate.forecasts"
                    :forecast-windows="requiredActions.toValidate.forecastWindows"
                    :amount="amountToValidate"
                    :title="'Forecasts to validate'"
                    :action-color="'#544e58'"
                />
            </div>
            <div class="is-row" v-if="amountToSubmit > 0">
                <RequiredActionsItem
                    :forecast-windows="requiredActions.toSubmit.forecastWindows"
                    :amount="amountToSubmit"
                    :title="'Forecasts to submit'"
                    :action-color="'#116184'"
                />
            </div>
        </div>
    </div>
</template>
<script>
import forecastsService from "@/components/forecasts/forecastsService";
import { ROUTES } from "@/components/forecasts/router";
import RequiredActionsItem from "@/components/forecasts/elements/widgets/RequiredActionsItem";
import loader from "@/components/loader/loader";

export default {
    components: { RequiredActionsItem, loader },
    props: {
        showSpinner: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            requiredActions: null,
            isLoading: true,
            ROUTES
        };
    },
    async created() {
        this.isLoading = true;
        this.requiredActions = await forecastsService.getRequiredActions();
        this.$emit("areActionsRequired", this.amountTotal > 0);
        this.isLoading = false;
    },
    computed: {
        amountToPublish() {
            return this.requiredActions.toPublish.forecasts.length + this.requiredActions.toPublish.forecastWindows.length;
        },
        amountToSubmit() {
            return this.requiredActions.toSubmit.forecastWindows.length;
        },
        amountToValidate() {
            return this.requiredActions.toValidate.forecasts.length + this.requiredActions.toValidate.forecastWindows.length;
        },
        amountTotal() {
            return this.amountToPublish + this.amountToSubmit + this.amountToValidate;
        }
    },
    methods: {}
};
</script>
<style scoped lang="scss">
@import "../../../../assets/css/themes";
.requiredActions {
    text-transform: uppercase;
    background-color: #f4f4f4;
    padding: 5px 5px 40px 5px;
    .is-row {
        display: flex;
    }
    .header {
        background-color: $color2;
        font-weight: bold;
        padding: 5px 0;
        .text,
        .amount {
            font-size: 20px;
        }
        .amount {
            color: #ffffff;
            margin-right: 10px;
            margin-left: 8px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// RequiredActionsWidget.vue?2724083d